<template>
  <section class="site-top-spacing">

    <div class="container sticky-container" sticky-container>
        <div class="post-details-wrap ">

            <div class="post-detils-main">

                <div class="post-details-top">
                    <img :src="require(`@/assets/images/posts-img/${post.img}`)"  />
                </div><!-- /. Post-details-top -->

                <div class="post-details-bottom">
                    <div class="post-details-desc">
                        <h2>{{ post.title }}</h2>
                        <p>{{ post.desc }}</p>
                        <ul class="author-opt">
                            <li>
                                <router-link :to="{ name: 'profile', params: { name: post.author.userName }}">by @{{ post.author.name }}</router-link>
                            </li>
                            <li>
                                <base-dropdown>
                                    <div slot="title">
                                       
                                        <svg width="43px" height="11px" viewBox="0 0 43 11" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                                          <g id="more-vertical" transform="matrix(0.01745235 0.9998477 0.9998477 -0.01745235 0.5078125 1.222901)">
                                            <path d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z" transform="translate(0.2973022 16.94141)" id="Oval" fill="#214163" stroke="#214163" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z" transform="translate(0.6461792 32.92969)" id="Oval-Copy" fill="#214163" stroke="#214163" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z" transform="translate(0 0.00390625)" id="Oval" fill="#214163" stroke="#214163" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                                          </g>
                                        </svg>
                                    </div>

                                    <template>
                                        <li>
                                            <a href="#">See Transcript</a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <toggle-button style="margin-right: 5px;" :color="{checked: '#DAF7F7', unchecked: '#E9EBEF'}" :switch-color="{checked: '#00C6C6', unchecked: '#A6B2C0'}" :width="38" :height="22" />
                                                <span>Autoplay</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">Report</a>
                                        </li>
                                    </template>
                                </base-dropdown>
                            </li>
                        </ul>
                    </div><!-- /. post-details-desc -->

                    <div class="post-details-footer footer-social">
                      <ul>
                        <reaction-emoji :postReaction="post.postReaction"></reaction-emoji>                
                        <li>
                          <img class="share-icon" src="../assets/icon/repeat.svg" alt="share-icon" />
                          <span>4</span>
                        </li>
                        <li>
                          <img class="comment-icon" src="../assets/icon/message-circle.svg" alt="comment-icon" />
                          <span>0</span>
                        </li> 
                      </ul>
                      <div class="share-btn">
                        <img class="share-story" src="../assets/icon/share-icon.svg" alt="share-story" />
                        <span>Share</span>
                      </div>
                    </div><!-- /. post-social-share -->

                    <div class="post-detils-tags">
                        <div class="story-tag">
                            <button>pikachu</button>
                            <button>pokemon</button>
                            <button>detective pikachu</button>
                            <button>poke</button>
                        </div>
                    </div><!-- /. post-details-tags -->

                    <div class="comment-tab-wrap">
                        <div class="comment-tab">
                            <button @click="currentTab=1" :class="{ 'selectedTab' : currentTab == 1}" class="tab-btn">  
                                Comments (74)
                            </button>
                            <button @click="currentTab=2" :class="{ 'selectedTab' : currentTab == 2}" class="tab-btn">  
                                SHOUTOUTS (134)
                            </button>
                        </div>

                        <div class="comment-tab-details">
                            <div v-if="currentTab == 1" class="single-details-comments">
                                <post-details-comment></post-details-comment>
                            </div>
                            <div v-if="currentTab == 2" class="single-details-comments">
                                 <shoutouts-comment></shoutouts-comment>
                            </div>
                        </div>
                    </div><!-- /. post-details-comments -->

                </div><!-- /. Post-details-bottom -->

            </div><!-- /. post-details-wrap -->

            <div class="post-detils-sidebar">
                <h2>The Hunger Games Ris…. Series</h2>
                <div class="series-tab-wrap">
          
                  <div class="comment-tab-details">
                      <sidebar-series></sidebar-series>
                  </div>
                </div>
            </div><!-- /. post-details-wrap -->

        </div>
    </div>

  </section>
</template>


<script>

export default {

  data(){
    return{
      currentTab: 1,
      post:{
          id:1,
          type: 'story-card',
          title: 'The Hidden Story of Charlie Chaplin',
          img: 'p1.jpeg',
          desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum',
          author:{
            name: 'Dara Adhelia',
            userName:'daracantik',
            proPic: 'f1.png',
            verified: true
          },
          postReaction:[
            {
              userId:1,
              reaction:'love'
            },
            {
              userId:2,
              reaction:'wow'
            }
          ],
          postComments:[
            {
              userId:1,
              comment:"Comment goes to here.."
            },
            {
              userId:2,
              comment:"Comment goes to here.."
            },
            {
              userId:3,
              comment:"Comment goes to here.."
            }
          ],

        },
    }
  },

  methods:{
    numberFormat(value) {
      if(value>=1000000000000) {
          value=(value/1000000000000)+"TB"
      } else if(value>=1000000000) {
          value=(value/1000000000)+"B"
      } else if(value>=1000000){
          value=(value/1000000)+"M"
      } else if(value>=1000) {
          value=(value/1000)+"K";
      }

      return value;
    },
  }

}


</script>


<style>
    @import '../assets/css/post-detils.css';
</style>

